import React, { useEffect, useState } from "react";
import { List, Card, Typography, Descriptions, Button, Space, Popconfirm, message, Tooltip } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CmpyAddEdit from "./CmpyAddEdit";
import { UserService } from "../../../../Services/Manage/UserService";
import { LetterService } from "../../../../Services/Manage/LetterService";
import useMessage from "antd/es/message/useMessage";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const { Text } = Typography;



const CompanyLocation = () => {

  const perm = getPermission('/manage-letter-formats');
  const [data, setData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [message, msgContxt] = useMessage();

  const getAllFotter = async () => {
    try {
      const request = await LetterService.getAllFooter();
      setData(request.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllFotter();
  }, [])

  const handleAdd = () => {
    setEditingItem(null);
    setDrawerOpen(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setDrawerOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      const request = await LetterService.deleteFooter(id);
      if (request.status) {
        message.success(request.message);
        getAllFotter();
        setData((prev) => prev.filter((item) => item.id !== id));

      } else {
        message.error(request.message);
      }
    } catch (error) {
      console.error(error);
    }

  };

  const handleSubmit = async (values) => {

    const user = await UserService.getOmeUser();
    const payload = { ...values, added_by: user.uid };

    if (editingItem) {

      try {
        const request = await LetterService.updateFooter(payload, editingItem.id);
        if (request.status) {
          message.success(request.message);
          getAllFotter();
          setDrawerOpen(false);
        } else {
          message.error(request.message);
        }
      } catch (error) {
        console.error(error);
      }

    } else {

      try {
        const request = await LetterService.createFooter(payload);
        if (request.status) {
          message.success(request.message);
          const newItem = { ...values, id: Date.now() };
          getAllFotter();
          setData((prev) => [...prev, newItem]);
          setDrawerOpen(false);
        } else {
          message.error(request.message);
        }
      } catch (error) {
        console.error(error);
      }

    }

  };

  return (
    <>
      {msgContxt}
      <Card
        title="Company Locations"
        size="large"
     extra={
          <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
            <Button size="large" type="primary" icon={<PlusOutlined />} onClick={handleAdd} disabled={!perm.add}>
              Add Location
            </Button>
          </Tooltip>
        }
      >
        <List
          grid={{ gutter: 16, column: 2 }}
          dataSource={data}
          renderItem={(item) => (
            <List.Item key={item.id}>
              <Card
                title={<Text strong>{item.name}</Text>}
                
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
                extra={
                  <Space>
                    <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
                      <Button
                        size="large"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(item)}
                        disabled={!perm.edit}
                      />
                    </Tooltip>
                    <Popconfirm
                      title="Delete company?"
                      onConfirm={() => handleDelete(item.id)}
                      disabled={!perm.delete}
                    >
                      <Tooltip title={!perm.delete ? "You don't have permission to delete" : ""}>
                        <Button
                          size="large"
                          danger
                          icon={<DeleteOutlined />}
                          disabled={!perm.delete}
                        />
                      </Tooltip>
                    </Popconfirm>
                  </Space>
                }
              >
                <Descriptions column={1} size="small" variant="borderless">
                  <Descriptions.Item label="Phone">{item.phone}</Descriptions.Item>
                  <Descriptions.Item label="Email">{item.mail}</Descriptions.Item>
                  <Descriptions.Item label="Website">
                    <a href={item.website} target="_blank" rel="noreferrer">
                      {item.website}
                    </a>
                  </Descriptions.Item>
                  <Descriptions.Item label="Address">
                    {item.address_1}, {item.address_2}, {item.state} - {item.pincode},{" "}
                    {item.country}
                  </Descriptions.Item>
                  <Descriptions.Item label="Note">{item.note}</Descriptions.Item>
                </Descriptions>
              </Card>
            </List.Item>
          )}
        />
      </Card>

      {/* Drawer for Create/Edit */}
      <CmpyAddEdit
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editingItem}
      />
    </>
  );
};

export default CompanyLocation;
